var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tab-container', { dark: _vm.theme == _vm.THEMES.DARK }]},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.name,class:['tab-item', { active: _vm.selectedTab && _vm.selectedTab.name == tab.name }],on:{"click":function($event){return _vm.$emit('change', tab)}}},[_c('div',[_vm._v(_vm._s(tab.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }